import script from "./ProductDetailsTile.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailsTile.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailsTile.vue?vue&type=style&index=0&id=d74eb2d2&scoped=true&lang=css"
script.__scopeId = "data-v-d74eb2d2"

export default script